/**
 * break point 1024px에 따라
 * 모바일/데스크탑 여부를 반환
 */
export default {
  data() {
    return {
      checkMobile: false,
      matchMedia: window.matchMedia("(max-width: 1024px)")
    };
  },
  methods: {
    _handleScreenChange() {
      this.checkMobile = this.matchMedia.matches;
    }
  },
  computed: {
    mixinsIsMobile() {
      return this.checkMobile;
    }
  },

  mounted() {
    this._handleScreenChange();
    this.matchMedia.addEventListener("change", this._handleScreenChange);
  }
};
